<template>
  <div class="content-lg text-center">
    <img src="../../assets/img/info.svg" class="mb-40 ml-auto mr-auto" />
    <div class="text-bold">İşleminize şu an devam edemiyoruz.</div>
    <div class="mb-40">
      Sorununuzla ilgili bize
      <span class="text-bold">0 850 201 02 56</span> nolu telefondan ya da
      <span class="text-bold">expressdestek@bkm.com.tr</span> adresinden ulaşabilirsiniz.
    </div>
    <button class="outline" id="BtnGoToHome" @click="onClick">Anasayfaya Dön</button>
  </div>
</template>
<script>
export default {
  name: "ForgotPasswordError",
  methods: {
    onClick() {
      this.$router.push("/login");
    }
  }
};
</script>